


















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Warning extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly active!: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/components/warning/Warning.vue